import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { MessagePartKind } from "models/enumerations/conversations/message-part-kind";
import {
    RawMessagePart,
    SuggestMemoryPart,
} from "models/interfaces/conversations/message-part";
import MessagePartSuggestedMemoryRecord from "models/view-models/conversations/message-part-suggested-memory-record";

const defaultValues: SuggestMemoryPart = {
    kind: MessagePartKind.SuggestMemory,
    partId: undefined,
    additionalData: undefined,
    memory: undefined,
};

export default class SuggestMemoryPartRecord
    extends Record(defaultValues)
    implements SuggestMemoryPart
{
    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: RawMessagePart) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.memory != null) {
            params.memory = RecordUtils.ensureRecord(
                params.memory,
                MessagePartSuggestedMemoryRecord
            );
        }

        params.kind = MessagePartKind.SuggestMemory;

        super(params as Partial<SuggestMemoryPart>);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {RawMessagePart} values
     */
    public with(values: RawMessagePart): SuggestMemoryPartRecord {
        return new SuggestMemoryPartRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}
